export default __webpack_public_path__ + "static/app4-bccd4771fb6ef16347f3603502c56dbe.jpg";